module.exports = "video, audio, img {\n  max-width: 100%; }\n"